export default __webpack_public_path__ + "static/media/logo-mantenct.4545645d.svg";